// TableCategory.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Paper } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Sticky from 'react-stickynode';
import {
  StyledContainer,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledFirstHeaderCell,
  StyledMiddleHeaderCell,
  StyledLastHeaderCell,
  StyledHeaderBox,
  StyledTableRow,
  StyledModelCell,
  StyledModelBox,
  StyledModelImage,
  StyledModelName,
  StyledDescriptionCell,
  StyledCostCell,
} from './TableCategory.style';
import { useTranslations } from 'hooks/useTranslations';

const TableCategory = ({ data }) => {
  const { t } = useTranslations();
  const [isScrolled, setIsScrolled] = useState(false);
  const tableRef = useRef(null);
  const [navbarHeight, setNavbarHeight] = useState(64);

  useEffect(() => {
    const navbar =
      document.querySelector('header') ||
      document.querySelector('.navbar') ||
      document.querySelector('#navbar');
    if (navbar) {
      setNavbarHeight(navbar.offsetHeight);
    }
  }, []);

  const handleStateChange = ({ status }) => {
    setIsScrolled(status === Sticky.STATUS_FIXED);
  };

  return (
    <StyledContainer>
      <StyledTableContainer component={Paper} elevation={0} ref={tableRef}>
        <Sticky
          top={navbarHeight}
          innerZ={999}
          onStateChange={handleStateChange}
          enableTransforms={false}
          activeClass="sticky-active"
        >
          <div style={{ width: '100%', background: 'white' }}>
            <StyledTable>
              <StyledTableHead className={isScrolled ? 'sticky-header' : ''}>
                <StyledTableRow>
                  <StyledFirstHeaderCell>
                    <StyledHeaderBox>
                      {t('pricing_ai.token.model')}
                      <ArrowDownwardIcon
                        fontSize="small"
                        sx={{ ml: 1, color: '#BDBDBD' }}
                      />
                    </StyledHeaderBox>
                  </StyledFirstHeaderCell>
                  <StyledMiddleHeaderCell>
                    <StyledHeaderBox>
                      {t('pricing_ai.token.description')}
                      <ArrowDownwardIcon
                        fontSize="small"
                        sx={{ ml: 1, color: '#BDBDBD' }}
                      />
                    </StyledHeaderBox>
                  </StyledMiddleHeaderCell>
                  <StyledLastHeaderCell>
                    <StyledHeaderBox>
                      {t('pricing_ai.token.cost')}
                      <ArrowDownwardIcon
                        fontSize="small"
                        sx={{ ml: 1, color: '#BDBDBD' }}
                      />
                    </StyledHeaderBox>
                  </StyledLastHeaderCell>
                </StyledTableRow>
              </StyledTableHead>
            </StyledTable>
          </div>
        </Sticky>

        <StyledTable style={{ marginTop: isScrolled ? '0' : '0' }}>
          <tbody>
            {data?.map((model, index) => (
              <StyledTableRow key={model.id} index={index}>
                <StyledModelCell>
                  <StyledModelBox>
                    <StyledModelImage
                      src={model.user.profilePicture}
                      alt={model.name}
                    />
                    <StyledModelName variant="body1">
                      {model.name}
                    </StyledModelName>
                  </StyledModelBox>
                </StyledModelCell>
                <StyledDescriptionCell>
                  {model.description}
                </StyledDescriptionCell>
                <StyledCostCell>
                  {model.swiftaskTokenCoef}
                  {model.quantityLabel && (
                    <span style={{ fontWeight: 400 }}>
                      &nbsp;{model.quantityLabel}
                    </span>
                  )}
                </StyledCostCell>
              </StyledTableRow>
            ))}
          </tbody>
        </StyledTable>
      </StyledTableContainer>
    </StyledContainer>
  );
};

export default TableCategory;
